import { t } from '@lingui/core/macro'
import ECharts from '~/components/echarts'
import ReactController from '~/controllers/react_controller'
import { awsEC2CpuCapacityMonthlyUtilizationChartPath } from '~/routes'

export default class AWSEC2CpuCapacityMonthlyUtilizationChartController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    const url = awsEC2CpuCapacityMonthlyUtilizationChartPath(this.organizationIdValue)

    return (
      <ECharts
        title={t`Monthly CPU Capacity Utilization`}
        chartInfoTitle='aws_ec2_cpu_capacity_monthly_utilization'
        url={url}
        params={{}}
        showExportButton
      />
    )
  }
}
